import { render, staticRenderFns } from "./serviceOrderTable.vue?vue&type=template&id=5129742a&scoped=true&"
import script from "./serviceOrderTable.vue?vue&type=script&lang=js&"
export * from "./serviceOrderTable.vue?vue&type=script&lang=js&"
import style0 from "./serviceOrderTable.vue?vue&type=style&index=0&id=5129742a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5129742a",
  null
  
)

export default component.exports